module.exports = __webpack_public_path__ + "img/uk-ua.9153014d.svg";